<app-nav [navItems]="navItems" />

<div class="container">
  @if (hasItemsInCart$ | async) {
    <div class="cart">
      <app-cart-form />
    </div>
  } @else {
    <app-empty-block title="At the moment, you have no items in your cart.">
      <p>
        Explore our extensive selection of stock videos in our database and find
        the perfect high-quality content for yourself.
      </p>
    </app-empty-block>
  }
</div>
